/**
 * Blog voice "Start this" boot capture (CEL-3260; see blogVoiceHandoff.js for the whole carry). Imported by index.js only:
 * it holds the one network call, so the storage helpers stay import-light for RootRoute.
 */
import { postBlogVoiceStartThis } from '../services/blogVoiceApi';
import { normalizeBlogVoiceSessionId } from './firstTouch';
import { isHirePath, parseBlogVoiceHire, stashBlogVoiceHire } from './blogVoiceHandoff';

const START_SENT_PREFIX = 'cellcog_bv_start_this_';
// public/index.html takes `role` and `brief` off the address bar BEFORE any analytics script reads it (the reader's task text never
// lands in a page_view URL; Nora, CEL-3263) and parks the original query under this key for the capture below. Same key in both.
export const LANDING_SEARCH_KEY = 'cellcog_bv_landing_search';

const landingSearch = () => {
  let parked = null;
  try {
    parked = sessionStorage.getItem(LANDING_SEARCH_KEY);
    sessionStorage.removeItem(LANDING_SEARCH_KEY);
  } catch (e) {
    parked = null;
  }
  return parked || window.location.search;
};

/** On the hire path: stash a blog-voice brief, and stamp start-this once per browser session when `vs` is present. Fail-soft. */
export function captureBlogVoiceHire() {
  try {
    if (!isHirePath(window.location.pathname)) return;
    const search = landingSearch();
    stashBlogVoiceHire(parseBlogVoiceHire(search));
    const vs = normalizeBlogVoiceSessionId(new URLSearchParams(search).get('vs'));
    if (vs && !sessionStorage.getItem(START_SENT_PREFIX + vs)) {
      sessionStorage.setItem(START_SENT_PREFIX + vs, '1');
      postBlogVoiceStartThis(vs).catch(() => { /* best-effort; the server stamp is idempotent */ });
    }
  } catch (e) {
    // fail-soft: the handoff must never break the app
  }
}

export default captureBlogVoiceHire;
